var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common page-btns-father" },
    [
      _c("div", { staticClass: "page-btns-main" }, [
        _c("div", { staticClass: "common-title" }, [_vm._v("融资信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "page-main no-shadow spaceLeft",
            staticStyle: { "padding-bottom": "6px" }
          },
          [
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("银行名称：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.tenantName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("申请日期：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(
                            _vm.pageData.fncBgDt,
                            "YYYY-mm-dd"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("申请编号：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.fncJrnlId))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("意向放款日期：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(_vm.pageData.fncDt, "YYYY-mm-dd")
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("资金用途：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.rmrk))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("到期日期：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(
                            _vm.pageData.goldList &&
                              _vm.pageData.goldList[0] &&
                              _vm.pageData.goldList[0].exDay,
                            "YYYY-mm-dd"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("还款方式：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("rpMdCdTrans")(_vm.pageData.instmRepyTpCd)
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("融资金额：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(
                        _vm._s(_vm._f("splitK")(_vm.pageData.thsFncAmt)) + " 元"
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("利率(%)：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.yrRate))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("预估利息：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.interest) + " 元")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("融资手续费率(%)：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(
                        _vm._s(_vm._f("splitK")(_vm.pageData.financingFeeRatio))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("预估融资手续费：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm._f("splitK")(_vm.pageData.fee)) + " 元")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("平台服务费：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(
                        _vm._s(_vm._f("splitK")(_vm.pageData.platformInt)) +
                          " 元"
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("合计金额：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _c("span", { staticClass: "fin-num" }, [
                        _vm._v(_vm._s(_vm._f("splitK")(_vm.pageData.totalAmt)))
                      ]),
                      _vm._v("\n            元")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "common-title" }, [_vm._v("祺信信息")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("a-table", {
              attrs: {
                size: "middle",
                columns: _vm.goldColumns,
                "row-key": function(record) {
                  return record.gldId
                },
                "data-source": _vm.pageData.goldList,
                bordered: "",
                pagination: false,
                locale: { emptyText: "暂无数据" }
              },
              scopedSlots: _vm._u([
                {
                  key: "gldAmt",
                  fn: function(text) {
                    return [_vm._v(_vm._s(_vm._f("splitK")(text)))]
                  }
                },
                {
                  key: "exDay",
                  fn: function(text) {
                    return [
                      _vm._v(_vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")))
                    ]
                  }
                },
                {
                  key: "canBeModified",
                  fn: function(text) {
                    return [_vm._v(_vm._s(_vm._f("gbCbmTrans")(text)))]
                  }
                },
                {
                  key: "oper",
                  fn: function(text, record) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function($event) {
                              return _vm.toGoldDetail(record)
                            }
                          }
                        },
                        [_vm._v("详情")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "common-title",
            staticStyle: { "margin-top": "16px" }
          },
          [_vm._v("贸易资料")]
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("a-table", {
              attrs: {
                size: "middle",
                columns: _vm.fileColumns,
                "row-key": function(record) {
                  return record.fileId
                },
                "data-source": _vm.fileList,
                bordered: "",
                pagination: false,
                locale: { emptyText: "暂无数据" }
              },
              scopedSlots: _vm._u([
                {
                  key: "invoiceType",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("invoiceTypeFilter")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceNumber",
                  fn: function(text, record) {
                    return [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toInvoiceInfo(record)
                            }
                          }
                        },
                        [_vm._v(_vm._s(text))]
                      )
                    ]
                  }
                },
                {
                  key: "billTime",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceAmountWithVat",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("splitK")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "contractNo",
                  fn: function(text, record) {
                    return [
                      text
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.contractInfoOpen(record)
                                }
                              }
                            },
                            [_vm._v(_vm._s(text))]
                          )
                        : _c("span", [_vm._v("--")])
                    ]
                  }
                },
                {
                  key: "otherFile",
                  fn: function(text, record) {
                    return [
                      record.uploaded
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toDeliveryCreate(record)
                                }
                              }
                            },
                            [_vm._v("查看")]
                          )
                        : _c("span", [_vm._v("--")])
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.relatedFileList.length > 0,
                expression: "relatedFileList.length > 0"
              }
            ]
          },
          [
            _c(
              "div",
              {
                staticClass: "common-title",
                staticStyle: { "margin-top": "16px" }
              },
              [_vm._v("其他资料")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-main no-shadow" },
              [
                _c(
                  "a-row",
                  _vm._l(_vm.relatedFileList, function(file, index) {
                    return _c(
                      "a-col",
                      {
                        key: index,
                        staticClass: "text-item-box",
                        attrs: { span: "12" }
                      },
                      [
                        _c("span", { staticClass: "text-item" }, [
                          _vm._v(" " + _vm._s(file.atchNm) + "： ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "text-color-blue",
                            on: {
                              click: function($event) {
                                return _vm.downFile(file)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(file.fileNm) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "common-title",
            staticStyle: { "margin-top": "16px" }
          },
          [_vm._v("收款账户")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-main no-shadow" },
          [
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("账户名称：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.accountName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("开户银行：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.withdrawAccountBank))
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("账户账号：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.withdrawAccountId))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { staticClass: "text-item-box", attrs: { span: "12" } },
                  [
                    _c("span", { staticClass: "text-item" }, [
                      _vm._v("大额行号：")
                    ]),
                    _c("span", { staticClass: "text-val" }, [
                      _vm._v(_vm._s(_vm.pageData.largeBankNo))
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "common-title" }, [_vm._v("相关协议")]),
        _vm._v(" "),
        _vm.agreementList[0] &&
        !_vm.agreementList[0].artcCntnt &&
        _vm.agreementList[0].file
          ? _c(
              "div",
              {
                staticClass: "page-main no-shadow",
                staticStyle: { "margin-bottom": "8px" }
              },
              [
                _c(
                  "a-row",
                  _vm._l(_vm.agreementList, function(item) {
                    return _c(
                      "a-col",
                      { key: item.id, attrs: { span: "12" } },
                      [
                        _c("div", { staticClass: "file-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.artcTtl) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-color-blue",
                            on: {
                              click: function($event) {
                                return _vm.downFile(item.file)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.file.fileNm) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.agreementList.length > 0,
                    expression: "agreementList.length > 0"
                  }
                ],
                staticClass: "page-main no-shadow",
                staticStyle: { "margin-bottom": "8px" }
              },
              _vm._l(_vm.agreementList, function(file, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "spaceLeft file-item" },
                  [
                    _c("div", { staticClass: "file-title" }, [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.showfileOnline(file)
                            }
                          }
                        },
                        [_vm._v("《" + _vm._s(file.artcTtl) + "》")]
                      )
                    ])
                  ]
                )
              }),
              0
            )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter page-bottom-btns" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn-blue-line",
              staticStyle: { margin: "30px 0" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceInfo",
        attrs: { readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("contractDialog", {
        ref: "contractInfo",
        attrs: { title: "匹配合同详情", readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("relatedFileDialog", { ref: "relatedFileDialog" }),
      _vm._v(" "),
      _c("serviceView", { ref: "serviceView" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4896774a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4896774a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/financing-page/financing-detail-page.vue
// module id = kHwF
// module chunks = 1